import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import api, { extractError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(data.message);
    } catch (err) {
      toast.error(extractError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto py-10" data-testid="forgot-password-page">
      <Card className="p-6 sm:p-8 space-y-5">
        <h1 className="urdu-naskh text-3xl font-semibold text-primary text-center">پاس ورڈ بھول گئے؟</h1>
        {sent ? (
          <div className="text-center space-y-3">
            <p className="urdu-naskh">
              اگر ای میل رجسٹرڈ ہے تو ری سیٹ لنک بھیج دیا گیا ہے۔ اپنی ای میل چیک کریں۔
            </p>
            <Button asChild variant="outline"><Link to="/login">لاگ اِن پر واپس</Link></Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="urdu-naskh text-sm text-muted-foreground">
              اپنی ای میل درج کریں، ہم آپ کو پاس ورڈ ری سیٹ کا لنک بھیجیں گے۔
            </p>
            <div className="space-y-1.5">
              <Label className="urdu-naskh">ای میل</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} dir="ltr" data-testid="forgot-email" />
            </div>
            <Button type="submit" disabled={busy} className="w-full bg-primary" data-testid="forgot-submit">
              {busy ? "بھیج رہا ہے…" : "ری سیٹ لنک بھیجیں"}
            </Button>
            <div className="text-center text-sm">
              <Link to="/login" className="text-primary underline">لاگ اِن پر واپس</Link>
            </div>
          </form>
        )}
      </Card>
    </div>
  );
}
